import React from 'react';
import PropTypes from 'prop-types';

export default function LegendDash(props) {
  return (
    <svg width={40} height={12} viewBox="0 0 40 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 2H40V10H0V2Z" fill="white" />
      <path d="M0 3H40V9H0V3Z" fill="#343434" />
      <path d="M10 3H16V9H10V3Z" fill={props.color || '#dddddd'} />
      <path d="M24 3H30V9H24V3Z" fill={props.color || '#dddddd'} />
      <path d="M0 3H2V9H0V3Z" fill={props.color || '#dddddd'} />
      <path d="M38 3H40V9H38V3Z" fill={props.color || '#dddddd'} />
    </svg>
  );
}

LegendDash.propTypes = {
  color: PropTypes.string
};